import { PREVIEW, pageType } from '@/pages/home/models/domain';
import request from '@/services/request';

const homeLevelApi = '/api/mall/rest/homepage/level/find';
const homeLevelApiPreview = '/api/mall/rest/homepage/level/preview';
/** 首页专栏接口：https://beukaygroup.feishu.cn/wiki/wikcnon4Wo4ofocY6hkTpEYAjWe */

export async function queryLevelData(
  type: string,
  shopCode: string,
  previewType: string,
  pageId: number,
) {
  let params: any;
  let api: string;
  api =
    pageType[previewType ?? ''] === PREVIEW
      ? homeLevelApiPreview
      : homeLevelApi;
  params = {
    mallType: 'TOB_MALL',
    platform: 'PC_MALL',
    pageType: 'FRONT_PAGE',
    shopCode,
    componentType: type,
  };
  if (pageType[previewType ?? ''] === PREVIEW) {
    params.pageId = pageId;
  }

  const result = await request<API.CommonResponse>({
    url: api,
    method: 'POST',
    data: params,
  });

  const { data } = result || {};
  return data;
}
